__turbopack_context__.v({
  "cardStyle": "card-stack-module-scss-module__1Vudsa__cardStyle",
  "cardWrapStyle": "card-stack-module-scss-module__1Vudsa__cardWrapStyle",
  "container": "card-stack-module-scss-module__1Vudsa__container",
  "wrapperStyle": "card-stack-module-scss-module__1Vudsa__wrapperStyle",
});
